import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import './redline.css';

const RedlineNotification = (props) => {
    const location = useLocation();

    const isDeals = matchPath(location.pathname, {
        path: '/deals',
        exact: true,
        strict: false,
    });

    const isForums = location.pathname.startsWith('/forums');

    let wrapperClass = 'red-wrapper';
    if (!isDeals && !isForums) {
        wrapperClass += ' hide-marquee';
    }
    if (isForums) {
        wrapperClass += ' forums-bg';
    }

    return (
        <div className={wrapperClass}>
            {isDeals && (
                <marquee>
                    Es su responsabilidad verificar y realizar sus propias diligencias.
                </marquee>
            )}
        </div>
    );
};

export default RedlineNotification;
